<template>
  <div id="widget" v-if="todo">
    <div id="reserva">
      <section class="cabecera row">
        <h3 class="col-12 titulo" v-text="initialRef.nombre"></h3>
        <select-language :idioma="idioma" @changeLanguage="changeLanguage"/>
      </section>
    </div>

    <section class="navegacion">
      <booking-steps :idioma="language.pasos" :step="step" v-shortkey="['ctrl', 'alt', 'z']" @shortkey.native="theAction()" />
    </section>

    <section class="estadoReserva" v-if="multiple && !verResumen" >
      <booking-summary :idioma="language.resumen"
                       @deleteRef="refrescar"
                       @cancelBooking="cancelarReserva"/>
    </section>

    <section class="padre" >
      <section class="habitaciones" v-if="selectRef" @change="seleccionarRefugio">
        <h5>Selecciona un refugio</h5>
        <select name="refugio" v-model="initialRef">
          <option value="0" default selected disabled>Ninguno seleccionado</option>
          <option :value="ref" :key="ref.id"
                  v-for="(ref) in refugiosSeleccionados">{{ref.nombre}}
          </option>
        </select>
      </section>
      <BookingContainer v-if="step==1 && refOk"
                        :refugio="initialRef"
                        :idioma="language.datosReserva"
                        :otros="otrosRefugios"
                        :multiple="multiple"
                        @nuevoRefugio="cambiaRefugio"
                        @seleccionServicios="haciaServicios"
                        @cancelBooking="cancelarReserva"
                        @errorHandler="showError"
      />
      <BookingServices v-if="step==2"
                       :idioma="language.datosServicios"
                       @cancelBooking="cancelarReserva"
                       @errorHandler="showError"
                       @toUserData="haciaUsuario"
      />

      <UserIdentify v-if="step==3"
                    :idioma="language.datosPersonales"
                    @toSummary="haciaResumen"
                    @cancelBooking="cancelarReserva"
                    @errorHandler="showError"/>

      <BookingConfirmation v-if="step==4"
                           :idioma="{ resumen: language.datosResumen, personales: language.datosPersonales}"
                           @cancelBooking="cancelarReserva"/>




      <span v-if="(!refOk && !verServicios && !verPersonales && !verResumen && !selectRef)">
        <i class="fa fa-4x fa-spinner fa-spin text-center"></i></span>

    </section>
    <ShowError v-if="viewError"
               :type-message="typeError"
               :text="errorMessage"
               @closeError="hideError" />
  </div>
</template>

<script>
  import { refugeService, customerService } from './_services'
  import {customerHelper, refugesHelper} from "./_helpers";
  import { mapGetters, mapMutations } from 'vuex'
  import SelectLanguage from './components/shared/SelectLanguage';
  import BookingSteps from './components/shared/BookingSteps';
  import BookingSummary from './components/shared/BookingSummary';
  import BookingContainer from './components/booking/BookingContainer'

  import language from './_locale';
  import BookingServices from "./components/services/BookingServices";
  import ShowError from "./components/shared/ShowError";
  import UserIdentify from "./components/shared/UserIdentify";
  import BookingConfirmation from './components/shared/BookingConfirmation'

  export default {
    name: 'local',
    props: ["refugio","idioma"],
    data () {
      return {
        todo:false,
        step:1,
        multiple: false,
        isGR11: false,
        language: null,
        initialRef:{},
        selectRef:false,
        special: false,
        otrosRefugios:null,
        refOk:false,
        verServicios: false,
        verPersonales: false,
        verResumen: false,
        viewError: false,
        typeError: 'error',
        errorMessage:''
      }
    },
    created(){
      this.todo = true
      let current = this.idioma || 'es';
      let lang = current === 'ca' ? 'es' : current
      refugeService.startBooking(lang)
      this.$store.commit('changeLanguage',current);
      this.language = language[current].texto;

      this.cargaRefugio()
      let customer = customerHelper.checkCurrent()

      if(customer.length > 0){
        this.setToken(customer)
        //this.showError({typeError:'success', errorMessage:customer})

        customerService.checkToken(customer)
          .then( rdo => {
            if(rdo.data.response)
              this.setCustomer(customerHelper.toForm(rdo.data.result))
          })
          .catch(err => {
            this.clearCustomer()
            customerHelper.setCookie('', true);
          })

        /*customerService.getLoggedUserInfo().then(data => {
          if(data.response) {
            this.setCustomer(customerHelper.toForm(data.result))
          }
        })*/
      }

    },
    computed:{
      refugiosSeleccionados() {
        return this.otrosRefugios || []
      }
    },
    methods:{
      ...mapGetters(['getBooking']),
      ...mapMutations(['cancelBooking','clearRefugeData','setCustomer','setToken','clearCustomer']),
      getRefugio(id){
        refugeService.getRefuge(id).then( data => {
          // Si se produce un error al traer el refugio se muestra
          if (data){
            this.initialRef = data
            this.refOk = true
          }else{
            this.showError({errorMessage:'Lo sentimos, hemos sufrido un problema técnico. Intentalo más tarde'})
            this.refOk = false
          }
        })
      },
      cargaRefugio() {
        if(typeof(this.refugio) === 'object'){
          this.selectRef = true
          this.special = true
          refugeService.getAll().then( data => {
            this.otrosRefugios = data.filter( ref => this.refugio.includes( ref.id ))
          })
        }
        else
          this.getRefugio(this.refugio)
      },
      seleccionarRefugio(){
        this.getRefugio(this.initialRef.id)
        this.selectRef = false
      },
      changeLanguage(lang){
        this.language = language[lang].texto;
      },
      cambiaRefugio(id){
        this.refOk = false
        this.getRefugio(id)
        const  a = this.getBooking().items.length
        if( a > 0) this.multiple = true
      },
      refrescar(){
        this.cambiaRefugio(parseInt(this.initialRef.id))
      },
      haciaServicios(){
        if(this.getBooking().items.length > 0){
          this.refOk = false
          this.verServicios = true
          this.step = 2
        }
      },
      haciaUsuario(){
        this.verServicios = false
        this.verPersonales = true
        this.step = 3
      },
      haciaResumen(){
        this.verServicios = false
        this.verPersonales = false
        this.verResumen = true
        this.step = 4
      },
      cancelarReserva() {
        // Mandar a la API lo que sea
        this.todo = false
        this.refOk=false
        this.verServicios = false
        this.verPersonales = false
        this.verResumen = false
        this.clearRefugeData()
        this.cancelBooking()
        // Crea una nueva reserva
        refugeService.startBooking()
        //this.getRefugio(this.refugio)
        this.cargaRefugio()
        this.todo = true
        this.step = 1

      },
      showError( { typeError, errorMessage }){
        this.typeError = typeError || 'error'
        this.errorMessage = errorMessage
        this.viewError = true
      },
      hideError(){
        this.viewError = false
      },
      theAction() {
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          redirect: 'follow',
          referrer: 'no-referrer',
          credentials:'include',
          cache: 'no-cache',
          mode: 'cors'
        }
        fetch('https://api.alberguesyrefugios.com/reservas/showPHPSession',requestOptions)
          .then(data => data.json()).then( res => console.log(res))
      }
    },

    components: {
      UserIdentify,
      ShowError,
      BookingServices,
      SelectLanguage,
      BookingSteps,
      BookingSummary,
      BookingContainer,
      BookingConfirmation
    }
  }
</script>
<style scoped>
  #widget{
    min-height: 450px;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue